import { z } from 'zod';
import GetDisclaimer from '@/app_gql/GetDisclaimer.gql';
import { GetData } from '@/app_lib/getData';

export const getDisclaimer = async () => {
  const GetDisclaimerResponse = z.object({
    generalSettings: z.object({
      footerContent: z.string().nonempty(),
    }),
  });

  type GetDisclaimerResponse = z.infer<typeof GetDisclaimerResponse>;

  const data = await GetData.content<GetDisclaimerResponse>(GetDisclaimer);

  if (!data.success) {
    throw new Error('HTTP Error');
  }

  const validatedData = await GetDisclaimerResponse.safeParseAsync(data.value);

  if (!validatedData.success) {
    throw new Error(`Validation Error: ${validatedData.error}`);
  }

  return validatedData.data.generalSettings.footerContent;
};
